import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import * as API from "../../libs/service";
import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Cookies from "js-cookie";

export default function Popup01(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        loginPop_navi_pw,
        loginPop_navi_google,
        max_width,
        sample_video,
        sample_video_src,
        leave,
        education,
        FreeCut,
        SubCutCancel,
        infolicense,
        deleteGroup
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);
    const terms = useSelector(state => state.etcReducer?.terms || undefined);

    const [LicenseidValue, setLicenseIdValue] = useState('');
    const [LicenseidErr, setLicenseIdErr] = useState(0);

    const [leaveMessage, setLeaveMessage] = useState(
        terms?.Withdraw?.[lang === 0 ? 'ko' : 'en']?.content || ''
    );

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    useEffect(() => {
        if (mbData?.idx) {
            setLicenseIdValue(mbData?.mb_email);
        }
    }, []);

    useEffect(() => {
        if (!LicenseidValue) {
            setLicenseIdErr(0)
        }
    }, [LicenseidValue]);

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "education_pop_input") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setLicenseIdValue(value)

            if (!EmailChk.test(value)) {
                setLicenseIdErr(1);
                return;
            } else {
                setLicenseIdErr(0);
            }
        }
    }

    return (
        <>
            <div
                className={"popup_default01"}
                style={{
                    maxWidth: max_width ? max_width : '400px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                    background: sample_video && sample_video_src ? 'none' : '',
                    position: sample_video && sample_video_src ? 'relative' : '',
                    borderRadius: sample_video && sample_video_src ? '20px' : '',
                    overflow: sample_video && sample_video_src ? 'hidden' : '',
                    border: sample_video && sample_video_src ? '4px solid #fff' : ''
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box"
                        style={{
                            padding: sample_video && sample_video_src ? '0' : '',
                            position: sample_video && sample_video_src ? 'absolute' : '',
                            zIndex: sample_video && sample_video_src ? '1' : '',
                        }}
                    >
                        {!sample_video && !sample_video_src ?
                            <img src={require("../../assets/images/exit-icon.svg").default}
                                className="popup_x_btn"
                                onClick={() => {
                                    dispatch(close());
                                }}
                                style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                            />
                            :
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(143, 8, 8, 0.5)',
                                    borderRadius: '100px',
                                    margin: '12px 12px 0 0',
                                    width: '32px',
                                    height: '32px'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(close());
                                }}
                            >
                                <img src={require("../../assets/images/exit-icon-white.svg").default}
                                    className="popup_x_btn"
                                    style={{
                                        cursor: isBrowser ? 'pointer' : 'auto',
                                    }}
                                />
                            </div>
                        }
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div
                    className="popup_content_box"
                    style={{
                        padding: sample_video && sample_video_src ? '0' : ''
                    }}
                >
                    {text1 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{lang === 0 ? text1 : text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{lang === 0 ? text1_b : text1_b}</b>
                        </div>
                    }

                    {text2 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{lang === 0 ? text2 : text2}</p>
                        </div>
                    }

                    {text2_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{lang === 0 ? text2_b : text2_b}</b>
                        </div>
                    }

                    {text3 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{lang === 0 ? text3 : text3}</p>
                        </div>
                    }

                    {text3_b &&
                        <div
                            className="popup_text_box"
                            style={{ marginTop: '20px' }}
                        >
                            <b>{lang === 0 ? text3_b : text3_b}</b>
                        </div>
                    }

                    {loginPop_navi_pw && // 이메일 가입된 계정 팝업
                        <div
                            className="popup_text_box navi_pw"
                        >
                            <p onClick={() => { }}>
                                {lang === 0 ? '비밀번호 변경' : 'Change Password'}
                            </p>
                            <span>{lang === 0 ? '이 필요합니다' : 'is required'}</span>
                        </div>
                    }

                    {loginPop_navi_google && // 이메일 가입된 계정 팝업
                        <div
                            className="popup_text_box navi_google"
                        >
                            <p>{lang === 0 ? '구글로 가입된 계정입니다.' : 'This account is registered with Google.'}</p>
                            <button
                                type="button"
                                className="sns_login_btn google"
                                style={{ marginTop: '32px' }}
                            >
                                <img src={require("../../assets/icon/google.svg").default} />
                                {lang === 0 ? '구글 로그인' : 'Google Login'}
                            </button>
                        </div>
                    }

                    {sample_video && sample_video_src && // 메인 비디오 샘플들
                        <div
                            className="popup_video_box"
                        >
                            <video
                                width="100%"
                                height="100%"
                                muted
                                loop
                                controls
                                autoPlay
                            >
                                <source src={sample_video_src} type="video/mp4" />
                                {lang === 0 ? '소개 영상입니다.' : 'This is an introduction video.'}
                            </video>
                        </div>
                    }

                    {title &&
                        <div
                            className="popup_title_box"
                        >
                            <p>{lang === 0 ? title : title}</p>
                        </div>
                    }

                    {subTitle &&
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{lang === 0 ? subTitle : subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lang === 0 ? text : text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lang === 0 ? lefttext : lefttext}</p>
                        </div>
                    }

                    {leave &&
                        <div className="popup_leave_box">
                            <div className="title_box">
                                <p>{lang === 0 ? '회원 탈퇴' : 'Delete Account'}</p>
                                <span
                                    onClick={() => {
                                        dispatch(open({
                                            component:
                                                <Popup01
                                                    x_btn={false}
                                                    text1={lang === 0 ? '회원탈퇴하시겠습니까?' : 'Do you want to delete?'}
                                                    buttonCancel={lang === 0 ? '탈퇴' : 'Delete'}
                                                    button={lang === 0 ? '아니오' : 'No'}
                                                    cancelFunc={() => {
                                                        dispatch(loadingStart());
                                                        API.deleteF('user', { id: mbData.idx })
                                                            .then(async res => {
                                                                console.log("res : ", res);
                                                                dispatch(open({
                                                                    component:
                                                                        <Popup01
                                                                            x_btn={false}
                                                                            text1={lang === 0 ? '탈퇴가 완료되었습니다.' : 'Delete successful.'}
                                                                            longButton={lang === 0 ? '확인' : 'OK'}
                                                                        />
                                                                }));

                                                                try {
                                                                    await API.post('auth/logout', {}, true);
                                                                } catch (err) {
                                                                    console.error(err);
                                                                }

                                                                dispatch(logOut());
                                                                dispatch(loadingEnd());
                                                                navigate(routes.main)
                                                            })
                                                            .catch(err => {
                                                                alert(lang === 0 ? '회원탈퇴에 실패했습니다.' : 'Delete failed.');
                                                                dispatch(loadingEnd());
                                                            });
                                                    }}
                                                />
                                        }));
                                    }}
                                >
                                    {lang === 0 ? '탈퇴하기' : 'Delete'}
                                </span>
                            </div>

                            <div className="content"
                                dangerouslySetInnerHTML={{ __html: leaveMessage }}
                            />
                        </div>
                    }

                    {education &&
                        <div className="education_pop_box">
                            <input
                                type="text"
                                className="education_pop_input"
                                placeholder={lang === 0 ? "이메일 주소 입력" : "Enter email address"}
                                name="education_pop_input"
                                value={LicenseidValue}
                                onChange={InputChange}
                            />
                            {LicenseidErr == 1 &&
                                <span className="err_msg id" >{lang === 0 ? '유효한 이메일 주소를 입력해 주세요.' : 'Please enter a valid email address.'}</span>
                            }
                        </div>
                    }

                    {FreeCut &&
                        <div className="popup_free_cut_text_box">
                            <p>
                                {lang === 0
                                    ? '무료 사용 기간 중 해지 요청 하면 그 즉시 해지되어\n더 이상 무료 체험 이용이 불가능 합니다.\n즉시 해지 되므로 해지 취소도 불가합니다.'
                                    : 'If you request cancellation during the free trial, it will be cancelled immediately, making you ineligible for further free trial use.\nCancellation is immediate and cannot be undone.'}
                            </p>

                            <span>{lang === 0 ? '구독을 해지하시겠습니까?' : 'Do you want to cancel the subscription?'}</span>
                        </div>
                    }

                    {SubCutCancel &&
                        <div className="popup_sub_cut_cancel_text_box">
                            {/* <div className="custom_chk_box profile lang">
                                <input
                                    type="radio"
                                    className="custom_chk_input"
                                    name="sub_cut_cancel"
                                    id="sub_cut_cancel1"
                                    checked
                                />
                                <label htmlFor="sub_cut_cancel1" className="custom_chk_label">
                                    {lang === 0 ? '구독no:' : 'Subscription No:'}
                                    <b> ABCD12345</b>
                                </label>
                            </div> */}

                            {/* <div className="custom_chk_box profile lang">
                                <input
                                    type="radio"
                                    className="custom_chk_input"
                                    name="sub_cut_cancel"
                                    id="sub_cut_cancel2"
                                />
                                <label htmlFor="sub_cut_cancel2" className="custom_chk_label">
                                    {lang === 0 ? '라이선스no:' : 'License No:'}
                                    <b> {infolicense}</b>
                                </label>
                            </div> */}

                            <span>{lang === 0 ? '구독해지를 취소하시겠습니까?' : 'Do you want to cancel the subscription termination?'}</span>
                        </div>
                    }


                    {(buttonCancel || button || longButton) &&
                        <div className="popup_btn_box">
                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if (cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {lang === 0 ? buttonCancel : buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    style={buttonCancel ? {} : { width: '100%' }}
                                    className={`button_success ${deleteGroup ? 'delete_group' : ''}`}
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {lang === 0 ? button : button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {lang === 0 ? longButton : longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}